/* eslint-disable @scandipwa/scandipwa-guidelines/only-one-class */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable max-classes-per-file */
import React, { lazy, Suspense } from 'react';

// Correctly specify the default import
export const VideoPlayer = lazy(() => import('./VideoPlayer').then(
/** @namespace Pwa/Component/BrandVideo/then */
    (module) => ({ default: module.VideoPlayer })
));

/** @namespace Pwa/Component/BrandVideo/LoadingPlaceholder */
export class LoadingPlaceholder extends React.Component {
    render() {
        return (
      <div
        className="loading-placeholder"
        style={ {
            position: 'relative',
            paddingTop: '56.25%',
            backgroundColor: '#f0f0f0'
        } }
      >
        <div
          style={ {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
          } }
        >
          Loading video...
        </div>
      </div>
        );
    }
}

/** @namespace Pwa/Component/BrandVideo/BrandVideo */
export class BrandVideo extends React.Component {
    __construct(props) {
        super.__construct(props);
        this.state = {
            isVisible: false
        };
        this.videoRef = React.createRef();
        this.observer = null;
    }

    componentDidMount() {
        this.observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    this.setState({ isVisible: true });
                    this.observer.disconnect();
                }
            },
            {
                root: null,
                rootMargin: '50px',
                threshold: 0.1
            }
        );

        if (this.videoRef.current) {
            this.observer.observe(this.videoRef.current);
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    render() {
        return (
      <div id="brandVideo" className="container" ref={ this.videoRef }>
        <h2>{ __('What Front Runner Dometic is all about') }</h2>
        { this.state.isVisible && (
          <Suspense fallback={ <LoadingPlaceholder /> }>
            <VideoPlayer
              src="https://customer-v69dny9pou827000.cloudflarestream.com/78b76601c4044d02d280115365a67fda/iframe"
              poster="https://customer-v69dny9pou827000.cloudflarestream.com/78b76601c4044d02d280115365a67fda/thumbnails/thumbnail.jpg?time=39s&height=600"
            />
          </Suspense>
        ) }
      </div>
        );
    }
}

export default BrandVideo;
